import { render } from "./GpsDeviceTransfer.vue?vue&type=template&id=4ae3fab0"
import script from "./GpsDeviceTransfer.vue?vue&type=script&lang=js"
export * from "./GpsDeviceTransfer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__